module.exports = __webpack_public_path__ + "static/media/phone_verification.5e6b5234.png";